import React from "react";
import Select from "react-select";
import styles from "../editLabReport.module.scss";

const titers = ["1:40", "1:80", "1:160", "1:320"];

const options = [
  { label: "+Ve", value: "+Ve" },
  { label: "-Ve", value: "-Ve" },
];

const parseTiterValues = (value) => {
  if (value && typeof value === "object" && !Array.isArray(value)) {
    return value;
  }

  if (typeof value !== "string" || !value) {
    return {};
  }

  try {
    const parsedValue = JSON.parse(value);
    return parsedValue &&
      typeof parsedValue === "object" &&
      !Array.isArray(parsedValue)
      ? parsedValue
      : {};
  } catch {
    return {};
  }
};

const WidalProfile = ({
  profile,
  comment,
  testMap,
  handleTestProfileChange,
}) => {
  const getValue = (test, titer) => {
    const testId = test.id || test._id;
    const testData = testMap.get(String(testId)) || {};
    return (
      parseTiterValues(testData.value)[titer] ||
      parseTiterValues(test?.value)[titer] ||
      ""
    );
  };

  const handleChange = (selected, profileId, testId, titer) => {
    if (!selected) return;

    const testData = testMap.get(String(testId)) || {};
    const prevValue = parseTiterValues(testData.value);

    const updatedValue = {
      ...prevValue,
      [titer]: selected.value,
    };

    handleTestProfileChange(
      { value: updatedValue },
      "value",
      profileId,
      testId,
    );
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <h4 style={{ fontWeight: "600" }}>Widal (Slide Method)</h4>

      {/* GRID TABLE */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "100px repeat(4, 1fr)",
          gap: "10px",
          alignItems: "center",
        }}
      >
        {/* Header */}
        <div></div>
        {titers.map((t) => (
          <div key={t} style={{ fontWeight: "600", textAlign: "center" }}>
            {t}
          </div>
        ))}

        {/* Rows */}
        {profile?.tests?.map((test) => {
          const testId = test.id || test._id;
          const profileId = profile.id || profile._id;

          return (
            <React.Fragment key={testId}>
              <div style={{ fontWeight: "500" }}>{test.testName}</div>

              {titers.map((titer) => {
                const currentValue = getValue(test, titer);

                return (
                  <div key={titer}>
                    <Select
                      placeholder="Select A Value"
                      value={
                        currentValue
                          ? {
                              label: currentValue,
                              value: currentValue,
                            }
                          : null
                      }
                      onChange={(selected) =>
                        handleChange(selected, profileId, testId, titer)
                      }
                      options={options}
                    />
                  </div>
                );
              })}
            </React.Fragment>
          );
        })}
      </div>

      {/* Impression */}
      <div style={{ marginTop: "20px" }}>
        <label>Impression</label>
        <textarea
          value={comment || ""}
          style={{
            width: "100%",
            height: "80px",
            border: "1px solid #ccc",
            borderRadius: "6px",
            padding: "8px",
          }}
          onChange={(e) =>
            handleTestProfileChange(e, "comment", profile.id || profile._id)
          }
        />
      </div>
    </div>
  );
};

export default WidalProfile;
